export function splitArtifactPathIntoFolderSegments(
  artifactVirtualPath: string | null | undefined,
): string[] {
  return (artifactVirtualPath || "")
    .split("/")
    .map((folderSegment) => folderSegment.trim())
    .filter(Boolean)
}
